export const AdminCancellationCodeVariable = '{DenticonCancelCode}';
export const SandboxAdminCancellationCode = '473';

export function hasSandboxAdminCancellationCode(getEffectiveFieldValueByVariable: (variable: string) => string): boolean {
    return getEffectiveFieldValueByVariable(AdminCancellationCodeVariable).trim() === SandboxAdminCancellationCode;
}
